/* Motiv card slider — powers arrow buttons + dots for scroll-snap tracks */
class MotivSlider extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('.motiv-slider__track');
    this.prev = this.querySelector('.motiv-slider__btn--prev');
    this.next = this.querySelector('.motiv-slider__btn--next');
    if (!this.track) return;

    this.onScroll = this.update.bind(this);
    this.track.addEventListener('scroll', this.onScroll, { passive: true });
    window.addEventListener('resize', this.onScroll, { passive: true });

    if (this.prev) this.prev.addEventListener('click', () => this.step(-1));
    if (this.next) this.next.addEventListener('click', () => this.step(1));

    this.update();
  }

  disconnectedCallback() {
    if (this.track) this.track.removeEventListener('scroll', this.onScroll);
    window.removeEventListener('resize', this.onScroll);
  }

  step(direction) {
    const first = this.track.children[0];
    const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
    const slide = first ? first.getBoundingClientRect().width + gap : this.track.clientWidth;
    this.track.scrollBy({ left: slide * direction, behavior: 'smooth' });
  }

  update() {
    if (!this.track) return;
    const max = this.track.scrollWidth - this.track.clientWidth;
    const scrollable = max > 2;
    this.toggleAttribute('data-scrollable', scrollable);
    if (this.prev) this.prev.disabled = this.track.scrollLeft <= 1;
    if (this.next) this.next.disabled = this.track.scrollLeft >= max - 1;
  }
}

if (!customElements.get('motiv-slider')) {
  customElements.define('motiv-slider', MotivSlider);
}
